import React from "react";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);

import GraphSkeleton from "../../ui/Skeleton/GraphSkeleton";
import PropTypes from "prop-types";
import _ButtonExportExcel from "../../_ButtonExportExcel";
const BarGraph = (props) => {
  const {
    data = [],
    loading = false,
    options = {},
    exportData = [],
    title = "",
  } = props;

  if (loading) {
    return (
      <div className="w-full h-full bg-white rounded-lg px-4 py-3">
        <GraphSkeleton />
      </div>
    );
  }

  if(data?.labels?.length === 0){
    return (
      <div className="w-full h-full bg-white rounded-lg px-4 py-3 flex items-center justify-center">
        <span className="material-symbols-outlined text-[50px] mb-1">
          bar_chart
        </span>
        <span className="text-gray-500">No hay información disponible</span>
      </div>
    );
  }
  return (
    <div className="w-full h-full bg-white rounded-lg px-4 py-3">
      <div className="flex justify-between">
        {title && <div className="text-lg font-bold">{title}</div>}
        <_ButtonExportExcel dataReport={exportData} />
      </div>
      <div className="grid grid-cols-1 h-96">
        <Chart type="bar" options={options} data={data} />
      </div>
    </div>
  );
};

BarGraph.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  options: PropTypes.object,
  exportData: PropTypes.array,
  title: PropTypes.string,
};

export default BarGraph;
